import { render } from "./view-internal-issue.vue?vue&type=template&id=ffc8b0ea&scoped=true"
import script from "./view-internal-issue.vue?vue&type=script&lang=js"
export * from "./view-internal-issue.vue?vue&type=script&lang=js"

import "./view-internal-issue.vue?vue&type=style&index=0&id=ffc8b0ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc8b0ea"]])

export default __exports__